<script>
import { euroCouponsCouponMethods } from "@state/helpers";

export default {
  name: "EuroCouponsCouponApprove",
  components: {},
  props: {
    errors: {
      type: Object,
      required: true,
    },
    oncomplete: {
      type: Function,
      required: false,
      default: () => ({}),
    },
    oncancel: {
      type: Function,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      modalShow: true,
      loading: true,
      submitting: false,
      toDelete: {},
    };
  },
  computed: {},

  mounted: function () {
    // let context = this;
    // if (context.instanceJson.url) {
    //   context.toDelete = {
    //     ...context.instanceJson,
    //   };
    //   context.getObject();
    // } else {
    //   context.oncancel();
    // }
  },

  methods: {
    // ...euroCouponsCouponMethods,
    // getObject() {
    //   let context = this;
    //   const promise = context.fetchEuroCouponsCouponDetail(context.toDelete.url);
    //   return promise
    //     .then((data) => {
    //       context.toDelete = { ...data };
    //       context.loading = false;
    //     })
    //     .catch((error) => {
    //       context.$axios_error_noty(error, context);
    //       context.loading = false;
    //       context.oncancel();
    //     });
    // },
    // approveObject() {
    //   let context = this;
    //   context.submitting = true;
    //   let payload = {
    //     action: "approve",
    //     coupons: [this.toDelete],
    //   };
    //   const promise = context.approveInactiveEuroCouponsCoupon(payload);
    //   return promise
    //     .then((data) => {
    //       context.$generate_toast(
    //         context,
    //         "success",
    //         `${context.$t("coupon")} ${context.$t("approved")} ${context.$t("correctly")}`
    //       );
    //       setTimeout(() => {
    //         context.submitting = false;
    //         context.oncomplete();
    //       }, 1000);
    //       if (data.length) {
    //         for (let error in data) {
    //           context.$generate_toast(
    //             context,
    //             "danger",
    //             `Error al enviar mensaje al beneficiario del bono ${error.coupon_id}`
    //           );
    //         }
    //       }
    //     })
    //     .catch((error) => {
    //       context.submitting = false;
    //       context.$axios_error_noty(error, context);
    //     });
    // },
  },
};
</script>

<template>
  <b-modal
    id="errors-modal"
    v-model="modalShow"
    :title="`Información`"
    ok-title="Cerrar"
    ok-variant="danger"
    @hidden="oncancel"
    @ok.prevent="oncancel"
  >
    <div v-for="(error, index) in errors" :key="index">
      <p>Error al enviar mensaje al beneficiario del bono {{ error.coupon_id }}</p>
    </div>
    <h5>Te recomendamos intentarlo de nuevo más tarde para estos bonos</h5>
  </b-modal>
</template>
<style lang="scss"></style>
